import * as actionTypes from './constants';

export const onProfilePressed = (profile) => (dispatch, getState) => {
    dispatch(showProfileToggle(profile));
}

export const showProfileToggle = (profile) => {
    return {
        type: actionTypes.SHOW_PROFILE_TOGGLE,
        profile
    }
}